import { JsonObject, JsonProperty } from 'json2typescript';
import { SearchParams } from '../searchParams';

@JsonObject('ContactSearchParams')
export class ContactSearchParams extends SearchParams {
    @JsonProperty('is_correspondance', Boolean, true)
    isCorrespondance = true;
}
